import { SITECONDITIONS_FETCH } from "../../actions/others/siteConditionActions";

const siteConditionReducer = (state: any[] = [], action: any) => {
  switch (action.type) {
    case SITECONDITIONS_FETCH:
      return action.payload;
    default:
      return state;
  }
};

export default siteConditionReducer;
